<template>
    <x-page title="Pindah Group">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        
        <form id="move-group-form" @submit.prevent="handleSubmit">
            <fieldset :disabled="isLoading">

                <x-form-group label="Group Lama" :error="getError('old_group')">
                    <multiselect open-direction="bottom"
                        :value="fields.old_group"
                        track-by="id" 
                        label="label"
                        :disabled="isLoading"
                        placeholder="Pilih Group"
                        :options="resource ? resource.groups : []"
                        :searchable="true" 
                        :allow-empty="false" 
                        :show-labels="false"
                        :internal-search="false"
                        class="form-control"
                        @input="value => fields.old_group = value">
                        <span slot="noResult">
                            Data tidak ditemukan.
                        </span>
                    </multiselect>
                </x-form-group>

                <x-form-group label="Group Baru" :error="getError('new_group')">
                    <x-ajax-dropdown url="/api/groups"
                        :blacklist="resource ? resource.groups.map(group => group.id) : []"
                        label="label"
                        :value="fields.new_group"
                        @input="value => fields.new_group = value"
                        class="form-control" />
                </x-form-group>
            </fieldset>
        </form>

        <template #footer>
            <x-submit-button form="move-group-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XAjaxDropdown from '../../components/XAjaxDropdown.vue'
import XBackButton from '../../components/XBackButton.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { formatForDateInput, handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import FormErrorMixin from '../../mixins/FormErrorMixin'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        XFormGroup,
        XAjaxDropdown,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            fields: {
                old_group: null,
                new_group: null,
            },
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/members/${this.$route.params.id}`, {
                params: {
                    load: 'groups'
                }
            })
            .then(response => {
                this.resource = {
                    ...response.data.data,
                    birthdate: formatForDateInput(response.data.data.birthdate),
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit() {
            this.isLoading = true
            const request = axios.post(`/api/members/${this.$route.params.id}/move-group`, {
                new_group: this.fields.new_group?.id,
                old_group: this.fields.old_group?.id,
            }).then(() => {
                this.$notify({
                    type: 'success',
                    title: `Berhasil`,
                    text: `${this.resource.name} updated!`,
                })
                this.$router.back()
            })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
    mixins: [
        FormErrorMixin,
    ],
}
</script>